'use client';
import React from 'react';
import { CustomerEmail as Shared } from '@launchstore/shared-puck';
import { useOrderData } from '@/lib/hooks/useOrderData';

const SharedRender = (Shared as any).render;

function CustomerEmailImpl(props: any) {
  const { order } = useOrderData();
  if (!order) return <SharedRender {...props} />;
  return <SharedRender {...props} email={order.email} />;
}

export const CustomerEmail: any = { ...Shared, render: (props: any) => <CustomerEmailImpl {...props} /> };
export default CustomerEmail;
